<template>
  <div style="width: 100%">
    <hr class="home-window-hr" />
    <div class="home-window-button-container">
      <slot />
      <input
        type="submit"
        :value="label"
        class="home-window-button"
        :class="{ disabled: disabled }"
        @click="click"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeWindowButton",
  props: {
    label: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    click() {
      this.$emit("buttonClick");
    }
  }
};
</script>

<style scoped>
.home-window-hr {
  margin: 0;
}
.home-window-button-container {
  padding-top: 10px;
}
.home-window-button {
  width: 100%;
  min-width: 100px;
  height: 24px;
  background-color: var(--primary-highlight);
  color: var(--main-white);
  border: 1px solid var(--primary-highlight);
  line-height: 8px;
  text-align: center;
  cursor: pointer;
  letter-spacing: 1.2px;
  font-size: 8px;
  text-transform: uppercase;
}
.home-window-button.disabled {
  pointer-events: none;
  opacity: 1;
  background-color: #f0f0f0;
  color: #b6b6b6;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/HomeWindowButton.vue